import React, { Component } from "react";

import Queries from "../../queries/queries2";
import SimpleSelect from "./SimpleSelect";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

class EnumSelect extends Component {
  render() {
    let options = [];
    if (this.props.enumQuery && this.props.enumQuery.__type) {
      options = this.props.enumQuery.__type.enumValues.map(enumValue => {
        return {
          label: this.props.intl.formatMessage({ id: enumValue.name }),
          value: enumValue.name
        };
      });
    }
    // console.log("options value", options, this.props.value)
    return (
      <SimpleSelect
        name={this.props.enumName}
        value={this.props.value}
        onSelected={this.props.onSelected}
        options={options}
      />
    );
  }
}

export default graphql(Queries.GET_ENUM_VALUES, {
  name: "enumQuery"
})(injectIntl(EnumSelect));
